import { taskShortTitle } from "./taskShortTitle";

function lines(items, empty) {
  const cleaned = (items || []).map((item) => String(item || "").trim()).filter(Boolean);
  if (!cleaned.length) return empty;
  return cleaned.map((item) => `- ${item}`).join("\n");
}

export function defaultHandoffPrompt(plan = {}, repo = {}) {
  if (String(plan.founderHandoffPrompt || "").trim()) return plan.founderHandoffPrompt;
  const title = taskShortTitle(plan.featureRequestText || "") || "this Task";
  const repoLabel = repo?.owner && repo?.name ? `${repo.owner}/${repo.name}` : "this repository";
  const criteria = plan.acceptanceCriteria || [];
  const steps = plan.planSteps || [];
  const parts = [
    `Implement this Task in ${repoLabel}: ${title}`,
    "",
    "What to build",
    String(plan.featureRequestText || "").trim() || "See the requirements below.",
    "",
    "Requirements",
    lines(criteria, "- Match the request above."),
  ];
  if (steps.length) {
    parts.push("", "Suggested steps", steps.map((step, index) => `${index + 1}. ${step}`).join("\n"));
  }
  parts.push("", "Do not change unrelated behavior.", "If a product decision is missing, stop and ask. Do not guess.");
  return parts.join("\n");
}

export function defaultHandoffPlan(plan = {}) {
  if (String(plan.founderHandoffPlan || "").trim()) return plan.founderHandoffPlan;
  const pack = String(plan.engineerStartPack?.markdown || "")
    .replace(/^Analyzed SHA:.*$/gim, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  if (pack) return pack;
  const parts = [];
  const goal = plan.planIntelligence?.goal || plan.planIntelligence?.pmSummary;
  if (goal) parts.push(`Goal\n${goal}`);
  if (plan.planIntelligence?.engineerSummary) {
    parts.push(`Plan\n${plan.planIntelligence.engineerSummary}`);
  }
  if (plan.planSteps?.length) {
    parts.push(`Steps\n${plan.planSteps.map((step, index) => `${index + 1}. ${step}`).join("\n")}`);
  }
  if (plan.acceptanceCriteria?.length) {
    parts.push(`Acceptance\n${plan.acceptanceCriteria.map((item) => `- ${item}`).join("\n")}`);
  }
  const files = (plan.recommendations || [])
    .slice(0, 12)
    .map((item) => item.filePath)
    .filter(Boolean);
  if (files.length) parts.push(`Files to touch\n${files.map((item) => `- ${item}`).join("\n")}`);
  return parts.join("\n\n").trim() || "Write the plan engineering should follow.";
}
